import { all, put, take } from 'redux-saga/effects';
import { LOGOUT } from '../type';
import { logoutSuccessAction, logoutErrorAction } from '../action';
import { history } from 'store';

function* logout() {
  while (1) {
    yield take(LOGOUT);
    try {
      yield put(logoutSuccessAction('Logged-out'));
      history.push('/');
    } catch (err) {
      yield put(logoutErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([logout()]);
}
